import { useEffect, useState } from 'react';
import HttpService from '../services/HttpService';


export const useFromAccessLogic = (formId?: number) => {

  const [availableForms, setAvailableForms] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchFormsState = async () => {
    try {
      setIsLoading(true);
      const resp = await HttpService.getAxiosClient().get(`/status/forms/${formId}`);
      setIsLoading(false);
      setAvailableForms(resp.data);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    } 
    
  };

  useEffect(() => {
    fetchFormsState();
  }, []);


  return {
    availableForms,
    isLoading
  };
};

